import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

export const ConceptsAddedComponent = ({
  data = [],
  formatter,
  handleRemoveConcept,
}) => {
  const totalSumatoria = data.reduce((acumulador, row) => {
    return acumulador + Number(row.IMPORTE_NETO_CONDICION || 0);
  }, 0);

  return (
    <>
      <Typography variant="h5" component="div">
        Conceptos añadidos
      </Typography>
      <hr />
      <TableContainer sx={{ padding: "5px 0px" }} component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow>
                <TableCell sx={{ width: "50%" }} align="center">Concepto</TableCell>
                <TableCell sx={{ width: "10%" }} align="center">Sub total</TableCell>
                <TableCell sx={{ width: "20%" }} align="center">Cantidad</TableCell>
                <TableCell sx={{ width: "10%" }} align="center">Total</TableCell>
                <TableCell sx={{ width: "10%" }} align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" sx={{ fontSize: "12px" }}>
                  {row.TXT_CONCEPTO}
                </TableCell>
                <TableCell align="center">
                  {formatter.format(Number(row.IMPORTE_CONDICION))}
                </TableCell>
                <TableCell align="center">
                  {Math.trunc(row.CANTIDAD)} 
                </TableCell>
                <TableCell align="center">
                  {formatter.format(Number(row.IMPORTE_NETO_CONDICION))}
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Eliminar">
                    <IconButton onClick={() => handleRemoveConcept(row)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {data.length > 0 && (
            <TableFooter>
              <TableRow sx={{ backgroundColor: "rgba(0, 0, 0, 0.02)" }}>
                <TableCell
                  colSpan={3}
                  align="right"
                  sx={{ fontWeight: "bold", fontSize: "14px" }}
                >
                  Total General:
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "var(--main-color-vino)",
                  }}
                >
                  {formatter.format(totalSumatoria)}
                </TableCell>
                <TableCell align="center" />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </>
  );
};
